var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pslfsm27wa",
    d: "M0 0.596L22.5 0.596 22.5 4.973 0 4.973z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M20.288 20.104H2.212c-.738 0-1.342-.603-1.342-1.341V3.399c0-.738.604-1.342 1.342-1.342h.587c.225 0 .44.093.594.258l1.403 1.503c.153.165.368.258.594.258h11.788c.237 0 .463-.103.616-.283l1.248-1.454c.155-.179.38-.282.616-.282h.63c.738 0 1.342.604 1.342 1.342v15.364c0 .738-.604 1.341-1.342 1.341"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M12.294 16.202c0 .577-.467 1.044-1.044 1.044s-1.044-.467-1.044-1.044.467-1.044 1.044-1.044 1.044.467 1.044 1.044M14.046 12.369H8.39c-.312 0-.565-.253-.565-.566V8.486c0-.312.253-.565.565-.565h5.655c.312 0 .565.253.565.565v3.317c0 .313-.253.566-.565.566"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .304)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4qbgwtrz1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pslfsm27wa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M21.614.596H.886C.396.596 0 .992 0 1.48v2.607c0 .49.397.885.886.885h20.728c.49 0 .886-.396.886-.885V1.48c0-.49-.396-.885-.886-.885",
    mask: "url(#4qbgwtrz1b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchives);
export default __webpack_public_path__ + "static/media/archives.1ed21eda604e83bb4859d38e20afdd7e.svg";
export { ForwardRef as ReactComponent };